/* eslint-disable react-hooks/exhaustive-deps */
import { Dispatch, HTMLAttributes, useEffect, useState } from "react";
import DragDrop from "../../widgets/drag-drop";
import Waveform from "../../widgets/webform";
import AnalyzeView from "./AnalyzeView";
import { Backend } from "shared-types";
import { CloseCircleOutlined, PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";
import { round } from "../../../utils";
import Progressbar from "../../widgets/progressbar";
import { Skeleton, Tooltip } from "antd";

export interface TrackUploadProps extends HTMLAttributes<HTMLDivElement> {
    file?: File | Blob | string;
    fileName?: string;
    setFile?: (file: File) => void;
    deleteFile?: () => void;
    uploadPercent?: number;
    status: TrackUploadStatus;
    setStatus: Dispatch<TrackUploadStatus>;
    isLoading: {
        file: boolean;
        meta: boolean;
    };
    audioMetaData?: Backend.T_AudioMetaData;

}

export enum TrackUploadStatus {
    IDLE, FILE_SELECTED, UPLOADING_FILE, PROCESSING_UPLOADS, ANALYZE_SUCCESS, ANALYZE_ERROR
}

export enum TrackAnalyzeStatus {
    PENDING, INPROGRESS, SUCCESSFUL, ERROR
}

const iconStyle = {
    style: { fontSize: '25px', color: 'white' },
    className: "tw-cursor-pointer"
}

const TrackUpload = (props: TrackUploadProps) => {
    const { file, setFile, deleteFile, uploadPercent, status, setStatus, isLoading, audioMetaData, fileName, ...rest } = props;
    const [fileObjectURL, setFileObjectURL] = useState<string | undefined>(undefined);
    const [isAudioPlaying, setAudioPlaying] = useState<boolean>(false);
    const [playingSecond, setPlayingSecond] = useState<number>(0);

    const onDropFile = (files: File[]) => {
        if (files && files.length && setFile) {
            setFile(files[0]);
            setStatus(TrackUploadStatus.FILE_SELECTED);
        }
    }

    useEffect(() => {
        if (file) {
            if (file instanceof File || file instanceof Blob) setFileObjectURL(URL.createObjectURL(file));
            else if (typeof file === "string") setFileObjectURL(file);
            else setFileObjectURL(undefined);
        }
        else setFileObjectURL(undefined);
    }, [file]);

    const setAudioPlayingStatus = (status: boolean) => {
        return () => setAudioPlaying(status);
    }

    return (
        <div {...rest}>
            {status === TrackUploadStatus.IDLE ? (
                <DragDrop
                    text="Drag your song here"
                    textHover="Release to drop song here"
                    onDropFile={onDropFile}
                    className="tw-text-[#037a9a]"
                />
            ) : (status === TrackUploadStatus.FILE_SELECTED || status === TrackUploadStatus.PROCESSING_UPLOADS || status === TrackUploadStatus.ANALYZE_SUCCESS || status === TrackUploadStatus.ANALYZE_ERROR) ? (
                <div className="tw-grid tw-grid-cols-1 tw-gap-5">
                    {fileObjectURL ? (
                        <Waveform
                            playing={isAudioPlaying}
                            url={fileObjectURL}
                            onPause={setAudioPlayingStatus(false)}
                            onPlay={setAudioPlayingStatus(true)}
                            onFinish={setAudioPlayingStatus(false)}
                            onPlaying={setPlayingSecond}
                        />
                    ) : ""}
                    {status === TrackUploadStatus.PROCESSING_UPLOADS ? (
                        <Progressbar width={uploadPercent || 0} />
                    ) : ""}
                    {status === TrackUploadStatus.ANALYZE_SUCCESS ? (
                        <Skeleton loading={isLoading.meta} >
                            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-3">
                                <div className="tw-flex tw-justify-center tw-text-center">
                                    <div className="tw-flex tw-items-center tw-space-x-2">
                                        {isAudioPlaying ? <PauseCircleOutlined {...iconStyle} onClick={setAudioPlayingStatus(false)} /> : <PlayCircleOutlined {...iconStyle} onClick={setAudioPlayingStatus(true)} />}
                                        <span className="tw-text-white tw-font-semibold">{audioMetaData?.Duration}</span>
                                        <span className="tw-text-white tw-font-mono"> / {round(playingSecond)} s</span>
                                    </div>
                                </div>
                                <AnalyzeView data={audioMetaData} fileName={fileName} />
                                <div className="tw-flex tw-justify-end">
                                    <div className="tw-flex tw-flex-col tw-justify-between">
                                        <Tooltip placement="left" title={"Upload another file"}>
                                            <CloseCircleOutlined {...iconStyle} onClick={deleteFile} />
                                        </Tooltip>
                                        {/* <Tooltip placement="left" title={"Analyzing"}>
                                            <LoadingOutlined  {...iconStyle} />
                                        </Tooltip> */}
                                    </div>
                                </div>
                            </div>
                        </Skeleton>
                    ) : ""}
                </div>
            ) : (
                ""
            )}
        </div>
    )
}

export default TrackUpload;